import { IApiAdQueryParams, IApiAdTargeting } from 'redux-state/advertisement/types.js';
import { IMarker } from 'types/markerCore/marker-core-type.js';
import { MarkerTypeGeneral } from 'types/markerTypes/location-markers-type.js';
import { matchLocationQuery } from 'utilities/fetch/url.js';
import { getFirstOfArr, isNotNullOrUndefined, predicateMarkerV1 } from 'utilities/isType.js';

const getMarkerBBQRating = (marker: IMarker[], location: string): number | undefined => {
  const findMarker = matchLocationQuery(location);
  const matching = marker.find(findMarker);
  if (matching) {
    if (predicateMarkerV1(matching)) {
      const markerSubject = getFirstOfArr(matching.subject);
      if (markerSubject) {
        const { type, value } = markerSubject;
        if (type === MarkerTypeGeneral.BBQ) {
          const currentBBQRatings = getFirstOfArr(value.bbqRatings);
          if (currentBBQRatings) {
            return currentBBQRatings.rating;
          }
        }
      }
    }
  }
  return undefined;
};

/**
 * This is used if we want to add any spcific ad targetting based on url query parameters
 * Currently only used for bbq-forecast
 */
export const addBBQQueryParamsTargeting = ({
  propNameTargetValue,
  urlQueryParams,
  markerData,
}: {
  propNameTargetValue: IApiAdQueryParams;
  urlQueryParams: URLSearchParams;
  markerData: IMarker[] | undefined;
}): IApiAdTargeting | undefined => {
  const { param, type } = propNameTargetValue;
  /**
   * Get BBQ Rating For Auckland
   * Find matching marker detail
   */
  const place = urlQueryParams.get(param); // 'auckland'
  if (markerData && place) {
    const bbqRating = getMarkerBBQRating(markerData, place);
    if (isNotNullOrUndefined(bbqRating)) {
      const key = type;
      const value =
        bbqRating.toString(); /** e.g. ['location', 'bbq-forecast-page']  => { 'bbq-forecast-page': 'auckland }*/
      return { key, value };
    }
  }
};
